import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PillarPage from "../pages/corporate-training/page";
import SalesTrainingPage from "../pages/sales-training/page";
import LeadersTrainingPage from "../pages/leaders-training/page";
import SoftSkillsPage from "../pages/soft-skills/page";
import TeamBuildingPage from "../pages/team-building/page";
import OnboardingPage from "../pages/onboarding/page";
import CorporateAcademyPage from "../pages/corporate-academy/page";
import EvaluationPage from "../pages/evaluation/page";
import StaffTrainingPage from "../pages/staff-training/page";
import CorpProgramPage from "../pages/corp-program/page";
import SalesTrainingSeoPage from "../pages/sales-training-seo/page";
import NegotiationTrainingSeoPage from "../pages/negotiation-training-seo/page";
import ObjectionTrainingSeoPage from "../pages/objection-training-seo/page";
import ColdCallsTrainingPage from "../pages/cold-calls-training/page";
import PhoneSalesTrainingPage from "../pages/phone-sales-training/page";
import NeedsAnalysisTrainingPage from "../pages/needs-analysis-training/page";
import B2BSalesTrainingPage from "../pages/b2b-sales-training/page";
import ClientRelationsTrainingPage from "../pages/client-relations-training/page";
import TextSalesTrainingPage from "../pages/text-sales-training/page";
import SalesHubPage from "../pages/sales-hub/page";
import EncyclopediaHubPage from "../pages/encyclopedia-hub/page";
import ManagementHubPage from "../pages/management-hub/page";
import LeadershipTrainingPage from "../pages/leadership-training/page";
import AboutTrainerPage from "../pages/about-trainer/page";
import ContactsPage from "../pages/contacts/page";
import DelegationTrainingPage from "../pages/delegation-training/page";
import FeedbackDifficultConversationsPage from "../pages/feedback-difficult-conversations/page";
import MotivationTeamManagementPage from "../pages/motivation-team-management/page";
import ConflictManagementPage from "../pages/conflict-management/page";
import ManagerialNegotiationsPage from "../pages/managerial-negotiations/page";
import LeaderInNegotiationsPage from "../pages/leader-in-negotiations/page";
import ChangeManagementPage from "../pages/change-management/page";
import ManagementCompetenciesPage from "../pages/management-competencies/page";
import MentoringDevelopmentPage from "../pages/mentoring-development/page";
import PersonnelDevelopmentPage from "../pages/personnel-development/page";
import AssessmentDevelopmentPage from "../pages/assessment-development/page";
import IPRPage from "../pages/ipr/page";
import TalentPoolPage from "../pages/talent-pool/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/enciklopediya-korporativnogo-obucheniya",
    element: <EncyclopediaHubPage />,
  },
  {
    path: "/prodazhi-i-peregovory",
    element: <SalesHubPage />,
  },
  {
    path: "/menedzhment-i-liderstvo",
    element: <ManagementHubPage />,
  },
  {
    path: "/menedzhment-i-liderstvo/trening-po-liderstvu",
    element: <LeadershipTrainingPage />,
  },
  {
    path: "/menedzhment-i-liderstvo/delegirovanie-i-postanovka-zadach",
    element: <DelegationTrainingPage />,
  },
  {
    path: "/menedzhment-i-liderstvo/obratnaya-svyaz-i-slozhnye-razgovory",
    element: <FeedbackDifficultConversationsPage />,
  },
  {
    path: "/menedzhment-i-liderstvo/motivatsiya-i-upravlenie-komandoy",
    element: <MotivationTeamManagementPage />,
  },
  {
    path: "/menedzhment-i-liderstvo/trening-po-upravleniyu-konfliktami",
    element: <ConflictManagementPage />,
  },
  {
    path: "/menedzhment-i-liderstvo/upravlencheskie-peregovory",
    element: <ManagerialNegotiationsPage />,
  },
  {
    path: "/menedzhment-i-liderstvo/rukovoditel-v-peregovorah",
    element: <LeaderInNegotiationsPage />,
  },
  {
    path: "/menedzhment-i-liderstvo/upravlenie-izmeneniyami",
    element: <ChangeManagementPage />,
  },
  {
    path: "/menedzhment-i-liderstvo/razvitie-upravlencheskih-kompetenciy",
    element: <ManagementCompetenciesPage />,
  },
  {
    path: "/menedzhment-i-liderstvo/nastavnichestvo-i-razvitie-sotrudnikov",
    element: <MentoringDevelopmentPage />,
  },
  {
    path: "/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie",
    element: <PillarPage />,
  },
  {
    path: "/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh",
    element: <SalesTrainingPage />,
  },
  {
    path: "/prodazhi-i-peregovory/trening-po-prodazham",
    element: <SalesTrainingSeoPage />,
  },
  {
    path: "/prodazhi-i-peregovory/trening-po-peregovoram",
    element: <NegotiationTrainingSeoPage />,
  },
  {
    path: "/prodazhi-i-peregovory/trening-po-rabote-s-vozrazheniyami",
    element: <ObjectionTrainingSeoPage />,
  },
  {
    path: "/prodazhi-i-peregovory/trening-po-holodnym-zvonkam",
    element: <ColdCallsTrainingPage />,
  },
  {
    path: "/prodazhi-i-peregovory/trening-po-telefonnym-prodazham",
    element: <PhoneSalesTrainingPage />,
  },
  {
    path: "/prodazhi-i-peregovory/trening-po-vyyavleniyu-potrebnostey",
    element: <NeedsAnalysisTrainingPage />,
  },
  {
    path: "/prodazhi-i-peregovory/trening-po-prodazham-b2b",
    element: <B2BSalesTrainingPage />,
  },
  {
    path: "/prodazhi-i-peregovory/trening-po-rabote-s-klientami",
    element: <ClientRelationsTrainingPage />,
  },
  {
    path: "/prodazhi-i-peregovory/trening-po-prodazham-cherez-perepisku",
    element: <TextSalesTrainingPage />,
  },
  {
    path: "/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley",
    element: <LeadersTrainingPage />,
  },
  {
    path: "/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills",
    element: <SoftSkillsPage />,
  },
  {
    path: "/enciklopediya-korporativnogo-obucheniya/komandoobrazovanie",
    element: <TeamBuildingPage />,
  },
  {
    path: "/enciklopediya-korporativnogo-obucheniya/adaptaciya-sotrudnikov",
    element: <OnboardingPage />,
  },
  {
    path: "/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya",
    element: <CorporateAcademyPage />,
  },
  {
    path: "/enciklopediya-korporativnogo-obucheniya/ocenka-effektivnosti-obucheniya",
    element: <EvaluationPage />,
  },
  {
    path: "/enciklopediya-korporativnogo-obucheniya/obuchenie-personala",
    element: <StaffTrainingPage />,
  },
  {
    path: "/enciklopediya-korporativnogo-obucheniya/razrabotka-programm-obucheniya",
    element: <CorpProgramPage />,
  },
  {
    path: "/o-trenere",
    element: <AboutTrainerPage />,
  },
  {
    path: "/razvitie-personala",
    element: <PersonnelDevelopmentPage />,
  },
  {
    path: "/razvitie-personala/otsenka-i-razvitie-sotrudnikov",
    element: <AssessmentDevelopmentPage />,
  },
  {
    path: "/razvitie-personala/individualnyy-plan-razvitiya-sotrudnikov",
    element: <IPRPage />,
  },
  {
    path: "/razvitie-personala/kadrovyy-rezerv",
    element: <TalentPoolPage />,
  },
  {
    path: "/contacts",
    element: <ContactsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;